'use strict';

var React = require('react');

var SvgLayoutPopupIcon = function SvgLayoutPopupIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M6.25 3.5c-1.519 0-2.75 1.231-2.75 2.75v.5c0 .414.336.75.75.75s.75-.336.75-.75v-.5c0-.69.56-1.25 1.25-1.25h.5c.414 0 .75-.336.75-.75s-.336-.75-.75-.75h-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M11.25 3.5c-1.519 0-2.75 1.231-2.75 2.75v2.5c0 1.519 1.231 2.75 2.75 2.75h2.5c1.519 0 2.75-1.231 2.75-2.75v-2.5c0-1.519-1.231-2.75-2.75-2.75h-2.5Zm-1.25 2.75c0-.69.56-1.25 1.25-1.25h2.5c.69 0 1.25.56 1.25 1.25v2.5c0 .69-.56 1.25-1.25 1.25h-2.5c-.69 0-1.25-.56-1.25-1.25v-2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.25 12.5c.414 0 .75.336.75.75v.5c0 .69.56 1.25 1.25 1.25h.5c.414 0 .75.336.75.75s-.336.75-.75.75h-.5c-1.519 0-2.75-1.231-2.75-2.75v-.5c0-.414.336-.75.75-.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5 13.25c0-.414-.336-.75-.75-.75s-.75.336-.75.75v.5c0 .69-.56 1.25-1.25 1.25h-.5c-.414 0-.75.336-.75.75s.336.75.75.75h.5c1.519 0 2.75-1.231 2.75-2.75v-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.25 8.25c.414 0 .75.336.75.75v2c0 .414-.336.75-.75.75s-.75-.336-.75-.75v-2c0-.414.336-.75.75-.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 15c-.414 0-.75.336-.75.75s.336.75.75.75h2c.414 0 .75-.336.75-.75s-.336-.75-.75-.75h-2Z"
  }));
};
SvgLayoutPopupIcon.displayName = "LayoutPopupIcon";

exports.SvgLayoutPopupIcon = SvgLayoutPopupIcon;
